<template>
  <ReactSiteFrame :src="src" />
</template>
<script>
import ReactSiteFrame from '../components/react/iframe'

export default {
  name: 'CreditsReact',
  components: {
    ReactSiteFrame
  },
  data() {
    return {
      src: '/view/account-credits'
    }
  }
}
</script>
